<template>
	<div class="page">
		<div class="ticket">
			<text-headline-primary class="ticket__headline">
				{{ texts.title }}
			</text-headline-primary>

			<div class="ticket__subtitle">
				{{ texts[downloadToken ? 'email' : 'snailmail'] }}
			</div>

			<div v-if="downloadToken" class="ticket__download-ticket">
				<text-button autofocus @click="downloadButtonAction">
					{{ texts.download_ticket }}
				</text-button>
			</div>
		</div>

		<div v-if="isArriva" class="promo">
			<div class="promo__container-1">
				<text-headline-primary class="promo__title">
					{{ texts.promo_title }}
				</text-headline-primary>

				<div class="promo__description1">
					{{ texts.promo_description1 }}
				</div>
				<br />
				<div class="promo__description2">
					{{ texts.promo_description2 }}
				</div>
			</div>

			<div class="promo__container-2">
				<text-headline-secondary class="promo__download-text">
					{{ texts.promo_download }}
				</text-headline-secondary>

				<div class="promo__buttons">
					<a
						href="https://play.google.com/store/apps/details?id=dk.arriva.mobilbillet&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
						class="promo__button"
					>
						<img alt="Get it on Google Play" src="@/assets/images/badges/google-play-badge.svg" class="promo__store-image" />
					</a>
					<a
						href="https://apps.apple.com/us/app/arriva-tog/id1335935955?itsct=apps_box_badge&amp;itscg=30200"
						class="promo__button"
					>
						<img
							src="@/assets/images/badges/apple-app-store-badge.svg"
							alt="Download on the App Store"
							class="promo__store-image"
						/>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextButton from '@/components/elements/TextButton'
import { FLOW_STEP_ORDER_CONFIRMED } from '@/store/modules/flow'

export default {
	components: {
		TextButton,
	},
	computed: {
		texts() {
			return this.$t('page_order_confirmed')
		},
		...mapGetters({
			downloadToken: 'order/getDownloadToken',
		}),
		isArriva() {
			return (
				document &&
				document.documentElement &&
				document.documentElement.classList.length &&
				[...document.documentElement.classList].includes('app-arriva')
			)
		},
	},
	mounted() {
		// push the token into the url if not there, so we can refresh
		if (this.downloadToken && this.$route.query.token !== this.downloadToken) {
			this.$router.replace({
				path: this.$route.path,
				query: {
					token: this.downloadToken,
				},
			})
		}

		// get the token from the url if we have refreshed
		if (this.$route.query.token && this.downloadToken !== this.$route.query.token) {
			this.$store.commit('order/setDownloadToken', this.$route.query.token)
		}

		this.$store.commit('flow/setStep', FLOW_STEP_ORDER_CONFIRMED)
	},
	methods: {
		downloadButtonAction() {
			window.open(process.env.VUE_APP_API_URL + 'v1/tickets/download?downloadtoken=' + this.downloadToken)
		},
	},
}
</script>

<style lang="scss" scoped>
.page {
	padding: 2rem 1rem;
	max-width: $breakpoint-tablet;
	margin: 0 auto;
}

.ticket {
	text-align: center;
	padding-bottom: 3em;

	@media (min-width: $breakpoint-tablet) {
		border-bottom: 0.0625rem solid #e2e2e2;
	}

	&__headline {
		padding-top: 1em;
	}

	&__subtitle {
	}

	&__download-ticket {
		padding-top: 1em;
	}
}

.promo {
	display: flex;
	flex-direction: column;
	text-align: left;
	justify-content: space-between;
	padding: 3em 0;

	@media (min-width: $breakpoint-tablet) {
		flex-direction: row;
		border-bottom: 0.0625rem solid #e2e2e2;
	}

	&__container-1 {
		display: flex;
		flex-direction: column;
		flex-basis: 65%;
	}

	&__title {
		font-size: 1.25rem;
	}

	&__container-2 {
		display: flex;
		flex-direction: column;
		flex-basis: 25%;
	}

	&__download-text {
		margin-top: 3.3125rem;

		@media (min-width: $breakpoint-tablet) {
			margin-top: 0;
		}
	}

	&__buttons {
		display: flex;
		column-gap: 1.1563rem;

		@media (min-width: $breakpoint-tablet) {
			flex-direction: column;
		}
	}

	&__store-image {
		width: 100%;
		height: 3.125rem;

		@media (min-width: $breakpoint-tablet) {
			width: 100%;
			height: 100%;
		}
	}
}
</style>
